import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/vercel/path0/src/app/(auth)/login/components/LoginForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/loader/loader.module.scss");
